import { createAuthClient } from 'better-auth/react';
import { adminClient, organizationClient } from 'better-auth/client/plugins';

/**
 * One client for sessions, the admin plugin (users) and the organization plugin
 * (tenants + members) — the same endpoints the API mounts.
 */
export const authClient = createAuthClient({
  basePath: '/api/auth',
  plugins: [adminClient(), organizationClient()],
});

export const { useSession, signIn, signOut } = authClient;
